import Model from "./base/model";

class TransporterDocument extends Model{
  resourceName() {
    return "transporter_documents";
  }

  fields() {
    return {
      name: "",
      path: "",
      type: "",
      verification: "",
      updated_at: "",
      observation:"",
      observation_to_banks: "",
      observation_to_taker: "",
      bank_to_taker_observation: "",
      is_expired: "",

      // sent_at: "",
      // transporter: {jsonApi: "hasOne", type: "transporters"},
      // fintech: {jsonApi: "hasOne", type: "fintechs"},
    }
  }
  async getByTransporter(id) {
    return this.request(
      this.resourceName() + "/transporter/"+id,
      "GET",
      {}
    );
  }

  async documentCheck(id, option) {
    return this.request(
      this.resourceName() + "/document_check/" + id +"/" + option,
      "POST",
      {},
      {}
    );
  }

  async updateObservation(data) {
    return this.request(
      this.resourceName() + "/observation/" + data.id,
      "PATCH",
      {},
      data,
      {},
      {},
    );
  }
}

export default new TransporterDocument();
